export default __webpack_public_path__ + "static/media/sunrise.26492782.svg";